/**
 * Created by xadrian on 17/05/18.
 */
import number_format from './NumberFormat';

const money_format = (value)=>{
    return number_format(value,0,',','.');
}

export default money_format;